const userProfile = {
  pageTitle: 'הפרופיל שלי',
  toast: {
    success: 'הפרופיל עודכן בהצלחה.',
    error: 'אירעה שגיאה לא ידועה.',
  },
  tabs: {
    personalInfo: 'מידע אישי',
    security: 'אבטחה',
  },
  form: {
    personalDetails: {
      notice: 'הערה: מידע מסוים עשוי להיות גלוי לאנשים אחרים המשתמשים בשירותי מובקס.',
      title: 'פרטים אישיים',
      firstName: 'שם פרטי',
      lastName: 'שם משפחה',
      email: 'אימייל',
      phone: 'טלפון',
      gender: 'מין',
      genderOptions: {
        male: 'זכר',
        female: 'נקבה',
        default: 'מעדיף לא לציין / אחר',
      },
      dateOfBirth: 'תאריך לידה',
    },
    preferences: {
      title: 'העדפות',
      twoFactorAuth: 'אימות דו-שלבי (2FA)',
      twoFactorAuthWarning: 'שמירת הגדרה זו עשויה לנתק אותך מהמערכת\nודורשת כניסה מחדש.',
      twoFactorAuthNotice: 'אימות דו-שלבי (2FA) נדרש על פי מדיניות האתר ואינו ניתן להשבתה.',
      twoFactorAuthInfo: 'גישה לאתרים המחייבים 2FA עשויה להתגבר על העדפה זו.',
    },
    userRoles: {
      title: 'תפקידי משתמש',
      companyAdmin: 'מנהל חברה',
      site: 'אתר',
      role: 'תפקיד',
    },
    update: 'עדכן',
  },
  validations: {
    firstName: 'שם פרטי נדרש',
    lastName: 'שם משפחה נדרש',
    phone: {
      invalid: 'מספר טלפון אינו חוקי',
      required: 'טלפון נדרש',
      length: 'מספר הטלפון צריך להכיל בין 6 ל-16 ספרות',
    },
    email: {
      required: 'אימייל נדרש',
      email: 'כתובת אימייל לא חוקית',
    },
  },
};

export default userProfile;
